//#region src/repubs.ts
var e = [
	["OC", "/"],
	["US", "us/"],
	["DE", "de/"],
	["CO", "co/"],
	["AU", "au/"],
	["NZ", "nz/"],
	["IN", "in/"],
	["PT", "pt/"],
	["ZA", "za/"],
	["KE", "ke/"],
	["NG", "ng/"],
	["NL", "nl/"],
	["FR", "fr/"],
	["SE", "se/"],
	["SM", "sm/"],
	["CX", "cx/"],
	["CA", "ca/"],
	["ES", "es/"],
	["IT", "it/"],
	["BR", "br/"],
	["GZ", "/"],
	["WS", "/"]
];
function t(t, n) {
	let r = e.find(([e]) => e === t);
	if (!r) return n ? "/" : "";
	let i = r[1];
	return i === "/" ? n ? "/" : "" : `/${i.replace(/\/$/, "")}`;
}
function n(e) {
	return t(e, !1);
}
function r(e) {
	return t(e, !0);
}
function i(e, t) {
	let r = n(t);
	return r && (e === r || e.startsWith(`${r}/`)) ? e.slice(r.length) || "/" : e;
}
//#endregion
export { e as i, n, i as r, r as t };
